<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/geK7Y8/CoverDesign.jpg?1684604023738" alt="This image is the cover for the book Bound, Guards of Folsom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bound, Guards of Folsom
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Guards of Folsom: Book Five</i></b></p><p>Tek Cain &amp; Jamie Ryan work at the Guards of Folsom BDSM club. After two years on the run from their old motorcycle club and the Feds, Tek &amp; Jamie are finally able to relax and enjoy their new life in New York City. But the past won’t stay buried, and when the MC resurfaces, it’s Jamie who pays the price. Tek and the rest of the members at the Guards of Folsom must work together to get back one of their own.</p> <p>In this, the final installment in the Guards of Folsom series, everyone must come together, bound as one in their quest to find Jamie and bring him home once and for all.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        SJD Peterson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14b5c2d2